export default __webpack_public_path__ + "media/eric.83d58b1b.jpg";